import { LoadingPage } from '@/pages';
import { Suspense } from 'react';
import { useEditSheetContext } from '../../EditSheetContext';
import { AntragForm } from './AntragForm';
import { useTranslation } from 'react-i18next';

export function AntragWrapper() {
  const context = useEditSheetContext();
  const antraege = context.arbeitszeit.antraege ?? [];
  const sortedAntraege = antraege.sort(
    (a, b) =>
      (b.erstellungsdatum?.getTime() ?? 0) -
      (a.erstellungsdatum?.getTime() ?? 0),
  );
  const { t } = useTranslation();
  return (
    <>
      {antraege.length > 0 ? (
        <Suspense fallback={<LoadingPage />}>
          <AntragForm
            currentAntrag={sortedAntraege[0]}
            antraege={sortedAntraege}
            beginnAZ={context.arbeitszeit.start}
            endeAZ={context.arbeitszeit.ende}
          />
        </Suspense>
      ) : (
        <div className="flex flex-col items-start justify-center w-full h-full">
          {t('domain.arbeitszeiten.antrag.keineAntraegeVorhanden')}
        </div>
      )}
    </>
  );
}
